/**
 * Shared subtitle renderer for booking rows / flight legs. The chip data itself
 * (`SubtitleChip`) is platform-neutral and lives in client-core so the mobile
 * bookings screen builds the same chips; this renders it text-only,
 * bullet-separated, mapping the semantic `tone` onto a Tailwind class. `icon` is
 * kept on the shape because the checkout flow reuses the same chip data with icons.
 */

import type { SubtitleChip } from '@elara/client-core/lib/booking-metadata';

import React from 'react';

export type { SubtitleChip } from '@elara/client-core/lib/booking-metadata';

export function SubtitleChips({ chips }: { chips: SubtitleChip[] }): React.ReactNode {
  if (chips.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-1.5 text-muted-foreground text-xs mt-0.5">
      {chips.map((chip, i) => (
        <React.Fragment key={i}>
          {i > 0 && <span aria-hidden="true">·</span>}
          <span className={chip.tone === 'success' ? 'text-success' : undefined}>{chip.text}</span>
        </React.Fragment>
      ))}
    </div>
  );
}
